/* 
 * Changes the score by a random number and self destructs
 * */
function randomScoreUpdate({ gameState }) {
  gameState.updateScore(-100 + Math.floor(Math.random() * 201));
  return Promise.resolve();
}

export default randomScoreUpdate;
